import React, { useEffect, useState } from 'react';
import { Swords, FileCheck2, BookCheck, FileText } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../ui/tabs';
import { useAuth } from '../../context/AuthContext';
import { OpponentPanel } from './OpponentPanel';
import { ReviewPanel } from './ReviewPanel';
import { ResearchPanel } from './ResearchPanel';
import { ClientReportPanel } from './ClientReportPanel';

const TAB = 'data-[state=active]:bg-amber-500 data-[state=active]:text-slate-950 text-slate-300 text-xs gap-1';

// Cerebro+ tools for a case: opposing counsel AI, pre-filing review and verified research
export const CerebroPlusButton = ({ matter }) => {
  const { api } = useAuth();
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState({});
  useEffect(() => { if (open) api.get(`/cerebro/matters/${matter.id}/saved`).then((r) => setSaved(r.data)).catch(() => {}); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <button data-testid={`matter-cerebro-plus-btn-${matter.id}`} onClick={() => setOpen(true)}
        className="mt-2 w-full text-sm font-semibold rounded-lg py-2 flex items-center justify-center gap-2 bg-fuchsia-500/10 border border-fuchsia-500/40 text-fuchsia-200 hover:bg-fuchsia-500/20 transition-colors">
        <Swords className="w-4 h-4" />Cerebro+: contraparte, revisión, fallos e informe
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="cerebro-plus-dialog" className="bg-slate-950 border-slate-700 text-white max-w-3xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="pr-8">Cerebro+ · {matter.title}</DialogTitle>
            <DialogDescription className="text-slate-400">Maximiza tu probabilidad de victoria. Ningún resultado judicial puede garantizarse: revisa siempre el análisis.</DialogDescription>
          </DialogHeader>
          <Tabs defaultValue="opponent">
            <TabsList className="bg-slate-900 w-full grid grid-cols-2 sm:grid-cols-4 h-auto">
              <TabsTrigger value="opponent" data-testid="cerebro-tab-opponent" className={TAB}><Swords className="h-3.5 w-3.5" />Abogado contrario</TabsTrigger>
              <TabsTrigger value="review" data-testid="cerebro-tab-review" className={TAB}><FileCheck2 className="h-3.5 w-3.5" />Revisar escrito</TabsTrigger>
              <TabsTrigger value="research" data-testid="cerebro-tab-research" className={TAB}><BookCheck className="h-3.5 w-3.5" />Fallos verificados</TabsTrigger>
              <TabsTrigger value="report" data-testid="cerebro-tab-report" className={TAB}><FileText className="h-3.5 w-3.5" />Informe al cliente</TabsTrigger>
            </TabsList>
            <TabsContent value="opponent"><OpponentPanel matter={matter} initial={saved.opponent_analysis} /></TabsContent>
            <TabsContent value="review"><ReviewPanel matter={matter} /></TabsContent>
            <TabsContent value="research"><ResearchPanel matter={matter} initial={saved.verified_research} /></TabsContent>
            <TabsContent value="report"><ClientReportPanel matter={matter} /></TabsContent>
          </Tabs>
        </DialogContent>
      </Dialog>
    </>
  );
};
